import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import styles from './audit.module.css';
import AuditActivity from './AuditActivity';
import { getAuditLogs } from '../../common/constants/api';
import { getApplicantionInfo } from '../../common/utils/applicantionInfo';
import PopUp from '../../common/components/PopUp/PopUp';
import * as _ from 'lodash';
import CommonBtn from '../../containers/LeadProfile/CommonBtn/CommonBtn';
import CircularProgress from '@material-ui/core/CircularProgress';
import CommonFilter from '../../common/components/CommonFilter/CommonFilter';
import AuditNotes from '../Audit/AuditNotes/AuditNotes';
import Modal from '../../common/components/Modal/modal';
import moment from 'moment';

const { audit_frame, audit_initial, fixed_header } = styles;

const Audit = ({ showAuditTrail, setShowAuditTrail }) => {
  const [showAdit, setAdit] = useState(false);
  const [showAditActivity, setShowAditActivity] = useState(false);
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('');
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const auditContainer = useRef(null);
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [isItLoading, setLoading] = useState(false);
  const [pageInformationFromApi, setPageInfromationFromApi] = useState({});
  const [isItEnd, setEnd] = useState(false);
  const [showModalNotes, setShowModalNotes] = useState(false);
  const [activeSection, setActiveSection] = useState('ACTIVITY');
  const [filteredStartDate, setFilteredStartDate] = useState(false);
  const [filteredEndDate, setFilteredEndDate] = useState(false);
  const [noMessage, setNomessge] = useState(false);
  const [activityFilter, setActivityFilter] = useState(false);
  const [deletedSelectedDateFilter, setDeletedSelectedDateFilter] = useState(
    false
  );
  const [deletedActivity, setDeletedActivity] = useState(false);

  const showAuditlayout = async () => {
    await setAdit(true);
    setTimeout(() => setShowAditActivity(true), 1000);
  };
  useEffect(() => {
    if (showAuditTrail) {
      showAuditlayout();
    }
  }, [showAuditTrail]);

  const onclikEvent = () => {
    setAdit(false);
    setShowAditActivity(false);
    setShowAuditTrail(false);
  };

  const getLogDetails = async (
    laodingState = false,
    startDate = false,
    endDate = false,
    type = false
  ) => {
    setLoading(true);
    setNomessge(false);
    await setPopUpText('Loading....');
    await setPopUpType('loading');
    setShow(true);

    let size = _.get(pageInformationFromApi, 'size', 10),
      pageNo = _.get(pageInformationFromApi, 'number', 0);
    pageNo = laodingState == 'initialLoading' ? 0 : pageNo + 1;
    let fromDate = startDate ? startDate : filteredStartDate,
      toDate = endDate ? endDate : filteredEndDate;
    let activityType = type ? type : activityFilter;
    if (laodingState == 'removeFilters') {
      (fromDate = false), (toDate = false), (activityType = false);
      pageNo = 0;
    }

    getAuditLogs('leads', leadId, size, pageNo, fromDate, toDate, activityType)
      .then(response => {
        setLoading(false);
        if (response.error) {
          throw new Error(response);
        }
        setShow(false);
        laodingState == 'initialLoading' || laodingState == 'removeFilters'
          ? setData(_.get(response, '_embedded.eventResponseDtoList', []))
          : setData(
              data.concat(_.get(response, '_embedded.eventResponseDtoList', []))
            );
        if (_.get(response, '_embedded.eventResponseDtoList', []).length == 0) {
          setNomessge(true);
        }
        setPageInfromationFromApi(_.get(response, 'page', {}));
      })
      .catch(async error => {
        await setPopUpType('fail');
        await setPopUpText(error?.response?.data?.message.toString());
        setShow(true);
        setData([]);
        setPageInfromationFromApi({});
      });
  };
  useEffect(() => {
    getLogDetails('initialLoading');
  }, []);

  function isDivEnd(e) {
    if (
      auditContainer.current.offsetHeight + auditContainer.current.scrollTop >=
      auditContainer.current.scrollHeight - 100
    ) {
      let checkNextPage =
        parseInt(_.get(pageInformationFromApi, 'totalPages', 0)) -
        parseInt(_.get(pageInformationFromApi, 'number', 0));
      if (!isItLoading && checkNextPage > 1) {
        getLogDetails();
      } else if (!isItLoading) {
        setEnd(true);
      }
    }
  }

  const isNotesActive = activeSection === 'NOTES';
  const isActivityActive = activeSection === 'ACTIVITY';

  const addFilter = async filterData => {
    setFilteredStartDate(filterData['startDate']);
    setFilteredEndDate(filterData['endDate']);

    let activityType = false;
    await Object.keys(filterData.activityValues).map(function(key, index) {
      if (filterData.activityValues[key]) {
        if (key == 'all') {
          activityType = false;
        } else {
          setActivityFilter(key);
          activityType = key;
        }
      }
    });
    setData([]);
    setShow(true);
    getLogDetails(
      'initialLoading',
      filterData['startDate'],
      filterData['endDate'],
      activityType
    );
  };

  const removeFilter = () => {
    setData([]);
    setFilteredEndDate(false);
    setFilteredStartDate(false);
    setActivityFilter(false);
    getLogDetails('removeFilters');
  };

  const dateFormatTypeCommon = date => {
    if (date)
      return (
        moment(date)
          .date()
          .toString() +
        ' ' +
        moment(date)
          .format('MMM')
          .toString() +
        ', ' +
        moment(date)
          .year()
          .toString()
      );
  };

  let filteredData = [
    filteredStartDate
      ? dateFormatTypeCommon(filteredStartDate) +
        ' - ' +
        dateFormatTypeCommon(filteredEndDate)
      : null,
    activityFilter ? _.startCase(_.toLower(activityFilter)) : null
  ];

  const isFilteredData = () => {
    let isFitered = false;
    filteredData.map(each => {
      if (each) {
        isFitered = true;
      }
    });
    return isFitered;
  };

  const removeSelectedFilter = async index => {
    if (index == 0) {
      setFilteredEndDate(false);
      setFilteredStartDate(false);
      setDeletedSelectedDateFilter(true);
    }
    if (index == 1) {
      setActivityFilter(false);
      setDeletedActivity(true);
    }
  };
  useEffect(() => {
    if (!filteredEndDate && !filteredStartDate) {
      setData([]);
      getLogDetails('initialLoading');
    }
  }, [filteredEndDate, filteredStartDate]);

  useEffect(() => {
    if (!activityFilter) {
      setData([]);
      getLogDetails('initialLoading');
    }
  }, [activityFilter]);

  return (
    <div
      className={`h-full bg-black-700 float-right ${
        showAdit ? audit_frame + '  px-2' : audit_initial
      } `}
      ref={auditContainer}
      onScroll={isDivEnd}
    >
      <div className={`${fixed_header} fixed py-3`}>
        <div className={`py-2 flex`}>
          <p className="text-white font-roboto font-medium mr-auto text-base px-4 ">
            Audit trail
          </p>
          <div
            className="ml-auto float-right cursor-pointer"
            onClick={() => onclikEvent()}
          >
            <HighlightOffIcon style={{ color: 'gray' }} />
          </div>
        </div>

        {showAdit && (
          <div className="flex flex-row flex-wrap justify-around w-full">
            <div
              className="text-center flex mt-5 ml-7 flex-row-reverse "
              style={{ width: 'fit-content' }}
            >
              <CommonBtn
                value="Notes"
                stylesBtn={{
                  backgroundColor: isNotesActive ? '#FF8000' : '#FFFFFF',
                  color: isNotesActive ? 'white' : '#8697A7',
                  width: '7rem',
                  textAlign: 'center',
                  display: 'block',
                  borderColor: isNotesActive ? '#FF8000' : '#FFFFFF',
                  zIndex: '90',
                  marginLeft: '-18px',
                  paddingTop: '5px',
                  paddingBottom: '5px'
                }}
                onClick={() => {
                  setShowModalNotes(true);
                  setActiveSection('NOTES');
                }}
              />
              <CommonBtn
                value="Activity"
                stylesBtn={{
                  backgroundColor: isActivityActive ? '#FF8000' : '#FFFFFF',
                  color: isActivityActive ? 'white' : '#8697A7',
                  width: '7rem',
                  textAlign: 'center',
                  display: 'block',
                  borderColor: isActivityActive ? '#FF8000' : '#FFFFFF',
                  zIndex: '100',
                  paddingTop: '5px',
                  paddingBottom: '5px'
                }}
                onClick={() => {
                  setActiveSection('ACTIVITY');
                }}
              />
            </div>

            <div className=" w-full md:w-auto mt-5 mr-0 ml-auto">
              <CommonFilter
                onClikFilter={filterData => addFilter(filterData)}
                removeFilter={() => removeFilter()}
                deleteSelectedDateFilter={deletedSelectedDateFilter}
                deleteSelectedActivityFilter={deletedActivity}
              />
            </div>
          </div>
        )}
        <div className="w-full px-2 flex mt-4 ml-4">
          {filteredData.map((each, index) =>
            each ? (
              <div className="flex" key={index}>
                <div className="bg-grey-2222  py-1 px-2 rounded text-white font-roboto font-normal mx-1 my-3 text-xs">
                  {each}
                </div>
                <HighlightOffIcon
                  style={{
                    color: 'gray',
                    marginLeft: '-15px',
                    width: '18px',
                    cursor: 'pointer'
                  }}
                  onClick={() => removeSelectedFilter(index)}
                />
              </div>
            ) : null
          )}
        </div>
      </div>

      {showAditActivity ? (
        <div className={`w-full px-3 ${isFilteredData() ? 'mt-48' : 'mt-40'}`}>
          {isActivityActive
            ? data.map((each, index) => (
                <AuditActivity
                  key={index}
                  each={each}
                  page={pageInformationFromApi}
                  index={index}
                />
              ))
            : null}
          {noMessage ? (
            <p className="text-white font-roboto font-normal text-sm text-center">
              No Audit History Available!
            </p>
          ) : null}

          {/* /////////remove afte push */}
          {isNotesActive && (
            <Modal
              show={showModalNotes}
              setShow={setShowModalNotes}
              styleContainer={{
                width: '395px'
              }}
            >
              <h1 className="text-center text-base font-normal text-black-400 p-5">
                Coming Soon
              </h1>
            </Modal>
          )}
          {/* {isNotesActive && <AuditNotes isClosed={showAdit} />} */}
        </div>
      ) : null}
      {show ? (
        <div className="w-full mx-auto text-center items-center py-5">
          <CircularProgress style={{ color: '#FF8000' }} />
        </div>
      ) : null}
    </div>
  );
};
export default Audit;
